import { httpClient } from "@services/api/httpClient";

export async function submitOfferTechnicalAssessment(id: number, applicantId: number, answeredQuestions: Record<string, string>) {
  const response = await httpClient.post(`/offer-technical-assesment/answered-questions`, { offerId: id, offerApplicantId: applicantId, answeredQuestions });
  return response.data;
}